<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>EOD Logs</h2>
                    </div>
                    <div class="col-lg-4 col-6 text-right bid">
                    <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                    <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <!-- <form v-if="moduleName == 'ims'" @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchLog()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchLog" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>               -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="mt-2">Filters</h5>
              <span class="btn btn-outline-secondary" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row"  @submit.prevent=""  >
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Customer</label>
                    <multiselect 
                            v-model="selectedCustomer" 
                            @select="customerSelected()"
                            placeholder="Select Customer" 
                            :options="customerList" 
                            :multiple="false" 
                            label="customerFullName" 
                            track-by="id" >
                          </multiselect>
                  </div>
               
                  <div class="col-md-4 col-lg-3">
                          <label for="filter">Status</label>
                          <select v-model="selectedStatus" class="form-control" style="height: 40px;" >
                            <option value="">SELECT</option>
                            <option value="OPEN">OPEN</option>
                            <option value="SENT">SENT</option>
                          </select> 
                        </div>
                  <div class="col-md-4 col-lg-3">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="filelogs()" type="button" class="btn btn-success rounded mt-4">Filter</button>
                  </div>
                </form>
                
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerName'  ? 'sort-desc' : '']"  
                                    @click="sort('customerName')"
                                     >Customer</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'createdDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'createdDate'  ? 'sort-desc' : '']"  
                                    @click="sort('createdDate')"
                                     >Sent At</th> 
                                <th scope="col">Sent By</th>
                                 <!-- <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                                    @click="sort('status')"
                                     >Status</th>  -->
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'updatedDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'updatedDate'  ? 'sort-desc' : '']"  
                                    @click="sort('updatedDate')"
                                     >Last Opened At</th>  
                                        <th 
                                  scope="col" 
                                  class="sort text-center"
                                  >Read count</th>         
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>                 
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="logs.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in logs" :key="data.id">
                                <td>{{data.customerFirstName}}  {{data.customerLastName}} </td>
                                <td>{{ formatDate(data.createdDate) }}</td>
                                <td>{{ sentBy(data) }}</td>
                                <!-- <td>{{data.status == 'DRAFT' ? 'SENT' : data.status}}</td> -->
                                <td>{{ data.status == 'OPEN' ? formatDate(data.updatedDate) : "" }}</td>
                                <td class="text-center">
                                <!-- {{ data.readCount ? data.readCount : 0 }} -->
                                   <div>
                                    <button @click="viewReadCount(data)" class="btn btn-primary rounded ml-2 mt-0" type="button">
                                        <i class="fas fa-eye"></i>  {{ data.readCount ? data.readCount : 0 }}
                                    </button>
                                    </div>
                              </td>
                                <td class="text-center">
                                    <div v-if="data.s3Key">
                                    <button @click="downloadFile(data.s3Key)" class="btn btn-warning rounded ml-2 mt-0" type="button">
                                        <i class="fas fa-download"></i>  DOWNLOAD
                                    </button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example" v-if="!(logs.length == 0 && currentPage === 0)">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                    <a class="page-link cursor-pointer"   @click="previous()">
                                        <i class="fa fa-angle-left"></i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>
                                <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                <li class="page-item" v-bind:class="{ disabled: !hasNextPage }"  >
                                    <a class="page-link cursor-pointer" @click="next()">
                                        <i class="fa fa-angle-right"></i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        <!-- Pagination-->
                        <!-- <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="filelogs(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div> -->
                        </div>
                    </div>
                    </div>

                     <div
              class="modal fade"
              id="show-readcount"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <!-- <h5 class="modal-title">Confirm</h5> -->
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                     <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort" >Opened At</th>
                        </tr>
                    </thead>
                    <tbody class="list no-cursor">
                        <tr v-if="emailLog.length == 0 && !loading">
                            <td>
                                <p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="data in emailLog" :key="data.id">
                            <td>{{ formatDate(data.openedDate) }}</td>
                        </tr>
                    </tbody>
                </table>
                <b-pagination class="mt-4" :total-rows="totalRowsReadCount" v-model="currentPageReadCount" :per-page="perPageReadCount"
                    @input="getEmailReadCount()"></b-pagination>
                <div class="total-records">
                    <span>Total Records : {{totalRowsReadCount}}</span>
                </div>
                  </div>
                  
                </div>
              </div>
            </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 0,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "createdDate",
        sortOrder: "DESC",
        logs : [],
        moduleName : "",
        showFilters : false,
        customerId :"",
        fromDate : "",
        toDate : "",
        customerList : [],
        selectedCustomer : "",
        // statusList : [ "OPEN", "SENT" ],
        selectedStatus : "",
        emailLog : [],
        currentPageReadCount: 1,
        perPageReadCount: 25,
        totalRowsReadCount : 0,
        selectedEmailId : null,

     
    };
  },
  methods: {
     getEmailReadCount(emailId){
      if (emailId) {
        this.selectedEmailId = emailId;
      }

      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
         config.baseUrlAutoBidder +
          "/eod/emails-read-log?eodEmailId=" + this.selectedEmailId + "&page=" +
          this.currentPageReadCount +
          "&size=" +
          this.perPageReadCount,

          auth
      )
      .then(result => {
        this.totalRowsReadCount = result.data.pageInfo.totalElements;
        this.emailLog = result.data.content;
        this.loading = false;
      }).catch(() => this.loading = false);
  },
    // API dates look like "2025-02-27 04:26:30.568 UTC"; parse explicitly so every browser reads them
    formatDate(value){
        if(!value) return "";
        const m = this.moment.utc(value, ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss"]);
        return m.isValid() ? m.local().format("MMMM DD YYYY, h:mm:ss a") : "";
    },
    sentBy(data){
        const name = [data.createdFirstName, data.createdLastName].filter(n => n).join(" ");
        if (name) return name;
        // no sender name: emails sent by the scheduler are flagged isAutomatic
        return data.isAutomatic ? "Scheduler" : "N/A";
    },
    viewReadCount(content){
    // this.emailContent = content;
    console.log("read count data", content);
    this.selectedEmailId = content.id;
    this.currentPageReadCount = 1;
    this.emailLog = [];
    this.getEmailReadCount(content.id);
    window.$('#show-readcount').modal("show");

  },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.filelogs();
    },
    // default range: today -> tomorrow
    setDefaultDates(){
        this.fromDate = new Date();
        this.toDate = this.moment().add(1, "days").toDate();
    },
    clearFilter(){
        this.customerId = "";
        this.setDefaultDates();
        this.selectedCustomer = ""
        this.selectedStatus = ""
        this.filelogs();
    },
    searchLog(){
        this.currentPage = 0;
        this.filelogs();  
    },
    downloadFile(downloadKey){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    clearSearch(){
        this.searchValue = "";
        this.selectedCustomer = ""
        this.currentPage = 0;
        this.filelogs();  
    },
    next(){
        if(this.hasNextPage){
            this.currentPage++;
            this.filelogs(); 
        }
        
    },
    previous(){
        if(this.currentPage > 0){
            this.currentPage--;
            this.filelogs(); 
        }
        
    },
    filelogs(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD") : "";
      var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD") : "";
      var custId = this.selectedCustomer ? this.selectedCustomer.id : ""
      this.$http
        .get(
          config.baseUrlAutoBidder + "/eod/emails-log"+
          "?page="+this.currentPage+
          "&size="+this.perPage+
        //   "&searchText="+this.searchValue+
          "&from="+fDate+
          "&to="+tDate+
          "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
           "&customerId="+custId+
           "&status="+this.selectedStatus,
          auth
        )
        .then((result) => {
            // API returns { content: [...], pageInfo: { totalElements, ... } } (older versions: plain array)
            const data = result.data || {};
            this.logs = Array.isArray(data) ? data : (data.content || []);
            this.totalRows = data.pageInfo ? data.pageInfo.totalElements : this.logs.length;
            this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getCustomerList(){
        // this.loadingInit = true;
        const auth = {
            headers: { 'org-token': authService.getOrgToken() }
        };
        
        this.$http
            .get(
            config.baseUrlAutoBidder +
            `/customer/name-list`,
            auth
            )
            .then(response => {
            this.customerList = response.data.map((data) => {
                // Combine the name parts with spaces in between
                data.customerFullName = `${data.customerFirstName || ''} ${data.customerMiddleName || ''} ${data.customerLastName || ''}`.trim();
                return data;
                });
            // this.loadingInit = false;
            // this.init()

            //customerFullName
            })
        },
   
  },
  computed: {
    hasNextPage(){
        return (this.currentPage + 1) * this.perPage < this.totalRows;
    }
  },
  mounted() {
    this.setDefaultDates();
    this.filelogs();
    this.getCustomerList();
  }
};
</script>